
<template>
    <div class="row" id="weather" v-if="weather.isActive">
        <div class="col-md-4">
            <div class="title-section-toggle">
                <div class="content-title-section">
                    <div class="icon-section">
                        <span class="ptw-icon icons-beach-outline"></span>
                    </div>
                    <h3>{{__('messages.enjoy_weather')}} </h3>
                </div>
            </div>
        </div>
        <div class="col-md-8">
            <div class="content-section-toggle">
                <div class="content-toggle ap_contentToggle_2" 
                :style="{ height: vHeigth, overflow: 'hidden', paddingBottom: '40px', transition: vTransition }">
                    <div id="destinoWeather" class="ap_innerToggle">
                        <h4>{{__('messages.tips_weather')}} </h4>
                        <div class="destinoSide">
                            <div class="innerSide">
                                <ul class="ul-weather">                                   
                                    <li v-html="weather.tips">                                        
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <h4>{{__('messages.weather_at')}} {{city}}, {{countryName}}</h4>
                        <div v-html="weather.summary"></div>
                        <h4>{{__('messages.prepare_luggage')}} {{city}}</h4>
                        <div v-html="weather.toBring"></div>                        
                        <h4>{{__('messages.what_expect_weather')}} {{city}}</h4>                        
                        <div v-html="weather.weatherSeasonHtml"></div>
                    </div>
                    <div class="action-toggle">
                        <a href="#" class="btnTertiary btnTertiary--xs action-link ap_actionToggle" @click.prevent="toggleCollapse">
                            <span v-show="!isCollapse">{{__('messages.read_more')}}</span>
                            <span v-show="isCollapse">{{__('messages.read_less')}}</span>
                        </a>
                    </div>
            </div>
        </div>
    </div>
</div></template>


<script>
export default {
    props: {
        msg: String,
        weather: Object,
        city: String,
        countryName: String,
    },
    data() {
        return {
            name: "Weahter",
            isCollapse: false,
            vHeigth: '150px',
            vTransition: 'height 0.5s ease-out'
        };
    },
    methods: {
        toggleCollapse() {
            this.isCollapse = !this.isCollapse;

            if (!this.isCollapse) {
                this.vHeigth = '150px';
                // transition: height 0.5s ease-out;
            } else {
                this.vHeigth = 'fit-content';
                this.transition = 'height 0.5s ease-out';
            }

        }
    }
};
</script>